import { render, staticRenderFns } from "./EditTagModal.vue?vue&type=template&id=e97f566c&"
import script from "./EditTagModal.vue?vue&type=script&lang=js&"
export * from "./EditTagModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.cabcom.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e97f566c')) {
      api.createRecord('e97f566c', component.options)
    } else {
      api.reload('e97f566c', component.options)
    }
    module.hot.accept("./EditTagModal.vue?vue&type=template&id=e97f566c&", function () {
      api.rerender('e97f566c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/EditTagModal.vue"
export default component.exports